<template>
  <swiper class="swiper" :options="swiperOption">
    <template v-for="activity in activities.data">
        <swiper-slide>
            <activity :activity="activity" :lang="lang"></activity>
        </swiper-slide>
    </template>
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="swiper-btn-prev" slot="button-prev"><span class="material-icons">keyboard_arrow_left</span></div>
    <div class="swiper-btn-next" slot="button-next"><span class="material-icons">keyboard_arrow_right</span></div>
  </swiper>
</template>

<script>

  import {Swiper as SwiperClass, Pagination, Navigation, Mousewheel, Autoplay} from 'swiper/swiper.esm'
  import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
  import Vue from 'vue'

  SwiperClass.use([Pagination, Mousewheel, Navigation, Autoplay])
  Vue.use(getAwesomeSwiper(SwiperClass))
  const {Swiper, SwiperSlide} = getAwesomeSwiper(SwiperClass)
  import 'swiper/swiper-bundle.min.css'

  export default {
    props:["activities", "lang"],
    name: 'swiper-example-multiple-slides-per-biew',
    title: 'Multiple slides per view',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 4,
          spaceBetween: 24,
          slidesPerGroup: 3,
          pagination: {
            //el: '.swiper-pagination',
            //clickable: true
          },
          navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 4,
              spaceBetween: 16
            },
            768: {
              slidesPerView: 3,
              slidesPerGroup: 2,
              spaceBetween: 16
            },
            640: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 16
            },
            320: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 10
            }
          }
        }
      }
    }
  }
</script>